import React from 'react';
import {connect} from 'react-redux';
import {postToHub} from "../../actions/networkActions";
import {clearPayment} from "../../actions/paymentActions";
import PaymentConfirmationOverview from "../../components/PaymentConfirmationOverview";
import BackLink from "../../components/BackLink";
import {getProjectName} from "../../utils/themeUtils";

class PaymentConfirmationB2C extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderError: null,
            confirmationMail: null
        }
    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this._order();
    }

    //--

    _order() {
        let request = {
            confirmationMail: this.props.payment.confirmationMail,
            paymentReference: this.props.payment.paymentReference,
            mobileNumber: this.props.payment.mobileNumber,
            tomcatInstance: this.props.payment.tomcatInstance
        };

        postToHub("prebooking/order?bookingSource=webApp", request, this.onOrderCompleted, this.onOrderError);
    }

    onOrderCompleted = (response) => {
        const paymentData = this.props.payment;
        this.setState({
            confirmationMail: paymentData.confirmationMail,
            orderRequestResult: response,
            orderError: false
        });

        this.props.clearPayment();
    };

    onOrderError = (response) => {
        this.setState({
            orderError: true,
            orderRequestResult: response
        });
        console.error("error while executing order, response: ", response);
    };

    render() {

        if (this.state.orderError === null) {
            return (
                <div>
                    <div className="container mx-auto mt-4 text-primary-dark">
                        <div className="xl:inline xl:pr-2 text-4xl">
                            Placing your order...
                        </div>
                    </div>
                </div>
            )
        }

        if (this.state.orderError) {
            console.log("orderrequestresult", this.state.orderRequestResult);
            if(this.state.orderRequestResult?.response?.data === "Shoppingcart NOT bookable") {
                return (
                    <div className="container mx-auto mt-4 text-primary-dark">
                        <div className="text-4xl">
                            As the sold out item was not bookable, no payment has been taken from you for this booking. Please resubmit your booking.
                        </div>
                        <div className="my-4">
                            <BackLink to="/itinerary" text={`Return to ${getProjectName()} Planner`} />
                        </div>
                    </div>
                )
            }


            return (
                <div>
                <div className="container mx-auto mt-4 text-primary-dark">
                    <div className="xl:inline xl:pr-2 text-4xl">
                        We’re sorry, something went wrong while placing your order. Please contact Customer Services
                    </div>
                    <div className="mt-2 mb-2">
                        <a className="text-primary"
                           target="_blank"
                           rel="noopener noreferrer" href="https://www.tui.co.uk/destinations/contact-us">https://www.tui.co.uk/destinations/contact-us</a>
                    </div>
                    <div className="mb-4">
                        <BackLink to="/itinerary" text={`Return to ${getProjectName()} Planner`} />
                    </div>
                </div>
            </div>
            )
        }

        return (
            <PaymentConfirmationOverview
                bookingNr={this.state.orderRequestResult.groupReference}
                includePrintLink={false}
                confirmationMail={this.state.confirmationMail}
                logoutUserOnMount={false}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        payment: state.payment
    };
}

const mapDispatchToProps = {
    clearPayment
};


export default connect(mapStateToProps, mapDispatchToProps) (PaymentConfirmationB2C)



